var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-icon-list"},_vm._l((_vm.iconList),function(icon_e,icon_k){return _c('div',{key:icon_k,staticClass:"text-icon-list_content"},[_c('TextIcon',{attrs:{"text":icon_e.name,"icon":icon_e.icon}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }